/**
 * @fileoverview Lightweight BroadcastChannel-based query hint bus.
 * Used to fan-out cache hints across tabs without hitting the network.
 */

// Singleton channel (if available)
const CH_NAME = 'timegenie-query';
/** @type {BroadcastChannel | null} */
let ch = null;
try {
  if (typeof BroadcastChannel !== 'undefined') {
    ch = new BroadcastChannel(CH_NAME);
  }
} catch (_) {
  // no-op
}

/**
 * Publish a cache hint to other tabs.
 * @param {{ type: 'invalidate'|'patch', key?: any, entity?: 'tasks'|'goals'|'plans', userId?: string, payload?: any }} msg
 */
export function publishHint(msg) {
  try {
    if (!ch) return;
    ch.postMessage({ ...msg, ts: Date.now() });
  } catch (_) {
    // ignore
  }
}

/**
 * Subscribe to cache hints from other tabs.
 * @param {(msg: any) => void} fn
 * @returns {() => void} unsubscribe
 */
export function subscribeHints(fn) {
  if (!ch) return () => {};
  /** @param {MessageEvent} ev */
  const handler = (ev) => {
    try {
      if (!ev || !ev.data) return;
      fn(ev.data);
    } catch (_) {
      // ignore
    }
  };
  ch.addEventListener('message', handler);
  return () => {
    try {
      ch.removeEventListener('message', handler);
    } catch (_) {
      // ignore
    }
  };
}

export default { publishHint, subscribeHints };
